import "./styles/reset.css";

import "./styles/globals.css";

import "./styles/ft-habit.css";
import "./styles/switzer.css";

import { RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import { registerServiceWorker } from "./hooks/useServiceWorker";
import { router } from "./router";
import { periodicCheckForUpdates } from "./utils/check-for-updates";
import { handleDynamicImportErrors } from "./utils/vite";

handleDynamicImportErrors();
registerServiceWorker();

if (import.meta.env.PROD) {
  import("./utils/analytics")
    .then(module => {
      module.initialize();
    })
    .catch(console.error);
}

const rootElement = document.getElementById("root") as HTMLElement;

ReactDOM.createRoot(rootElement).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);

periodicCheckForUpdates();

const appleTouchIcon = document.querySelector("link[rel=apple-touch-icon]") as HTMLLinkElement;
const manifest = document.querySelector("link[rel=manifest]") as HTMLLinkElement;

if (import.meta.env.DEV) {
  appleTouchIcon.href = "/apple-touch-icon-test.png";
  manifest.href = "/site-test.webmanifest";
}
if (import.meta.env.VITE_TEST) {
  appleTouchIcon.href = "/apple-touch-icon-test.png";
  manifest.href = "/site-test.webmanifest";
}
if (import.meta.env.VITE_DEMO) {
  appleTouchIcon.href = "/apple-touch-icon-demo.png";
  manifest.href = "/site-demo.webmanifest";
}
